// The caption a Commons photo's view property earns, shared by the landmark
// cards and the place hero's set.
//
// The Wikidata view properties the gallery fetcher draws from, and the ONLY
// values that become a caption. Spelled out rather than trusting i18next to
// miss a key: `t(key, { defaultValue: '' })` treats an empty default as absent
// and renders the raw key, so an unknown property printed
// "landmarks.gallery.viewLabel.sunrise view" on the slide. An explicit set also
// puts the vocabulary where a reader can see it — it is closed, and 'main image'
// is deliberately NOT in it (an extra P18 is another photo, not another view).
const VIEW_LABELS = new Set([
  'interior', 'night view', 'aerial view', 'winter view',
  'entrance', 'panorama', 'view from here'
]);

// NAMESPACE-QUALIFIED on purpose. These keys live in `destination`, and a
// bare key resolves against whatever namespace the CALLER's `t` is bound
// to — so when the place page (bound to `details`) started sharing this,
// every caption rendered the raw key "landmarks.gallery.viewLabel.night view"
// on screen. An explicit prefix resolves the same from any caller, which is
// what makes this safe to share. Do not shorten it back.
export function viewLabelCaption(viewLabel, t) {
  return VIEW_LABELS.has(viewLabel) ? t(`destination:landmarks.gallery.viewLabel.${viewLabel}`) : '';
}
